
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import { api } from "../../../store/slices/authSlice";
import styles from "./StaticPage.module.css";
import { useTranslation } from "react-i18next";

export default function StaticPage({ endpoint, title }) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { i18n } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(endpoint);
        if (res.data.code === 200) setData(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [i18n.language]);

  const cleanText = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          <ArrowLeft size={18} />
        </button>
        <h1 className={styles.pageTitle}>{title}</h1>
      </div>

      <div className={styles.content}>
        <div className={styles.logoCircle}>
          {data?.image ? (
            <img src={data.image} alt="logo" className={styles.logoImg} />
          ) : (
            <div className={styles.logoPlaceholder} />
          )}
        </div>

        {loading ? (
          <div className={styles.cardSkeleton} />
        ) : (
          <div className={styles.card}>
            <h2 className={styles.cardTitle}>
              <span className={styles.bar} />
              {data?.title || title}
            </h2>

            <p className={styles.description}>
              {cleanText(data?.description) || "No content available."}
            </p>

            {data?.updated_at && (
              <div className={styles.updatedAt}>
                <Clock size={13} />
                Last updated:{" "}
                {new Date(data.updated_at).toLocaleDateString("en-CA")}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
